
/**
 * Serviço para lidar com conexões de carteira em dispositivos móveis
 */
export async function connectToMetaMaskMobile(): Promise<boolean> {
  try {
    // Verificar se estamos em um ambiente móvel
    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // Verifica se está no Chrome para Android
      const isChrome = /Chrome/i.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);
      
      // URL para abrir o app MetaMask com deep linking
      // Para Chrome no Android, usamos uma abordagem diferente
      let metaMaskAppUrl;
      
      if (isChrome && isAndroid) {
        // Use o formato 'https://metamask.app.link/dapp/' para Chrome no Android
        metaMaskAppUrl = 'https://metamask.app.link/dapp/' + window.location.host + window.location.pathname;
      } else {
        // Para outros navegadores em dispositivos móveis
        metaMaskAppUrl = 'https://metamask.app.link/dapp/' + window.location.host + window.location.pathname;
      }
      
      // Armazenar que uma tentativa de conexão está em andamento
      localStorage.setItem('walletConnectAttempt', 'true');
      
      // Redirecionar para o app MetaMask
      window.location.href = metaMaskAppUrl;
      
      return true;
    }
    
    return false;
  } catch (error) {
    console.error("Erro ao tentar conectar com MetaMask móvel:", error);
    return false;
  }
}

/**
 * Verifica se o usuário está retornando de uma tentativa de conexão com a carteira móvel
 */
export function checkMobileWalletReturn(): boolean {
  const hasAttemptedConnection = localStorage.getItem('walletConnectAttempt') === 'true';
  
  if (hasAttemptedConnection) {
    // Limpar o flag de tentativa
    localStorage.removeItem('walletConnectAttempt');
    return true;
  }
  
  return false;
}

